import { ProductCard } from 'components/ProductCard.tsx/ProductCard';
import { Loader } from '@wix/design-system';
import { useProductCatalog } from 'hooks/useProductCatalog';
import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { useAppStore } from 'stores/appStore';
import styles from '../SelectProductsStep.scss';

export const SelectProductsStepPreview: FC = () => {
  const { t } = useTranslation();
  const selectedProducts = useAppStore((state) => state.selectedProducts);
  const { isLoading } = useProductCatalog();

  return (
    <div className={styles.selectProductsStepPreview}>
      <div className={styles.selectProductsStepPreviewContent}>
        {isLoading && selectedProducts.length === 0 && (
          <div className={styles.selectProductsStepPreviewContentLoading}>
            <Loader size="medium" />
          </div>
        )}
        {!isLoading && selectedProducts.length === 0 && (
          <div className={styles.selectProductsStepPreviewContentEmpty} />
        )}
        {selectedProducts.map((product) => (
          <div key={product.id} className={styles.selectProductsStepPreviewContentItem}>
            <ProductCard
              buyButtonText={t('select-products-step.preview.product-card.button-text')}
              imageUrl={product.imageUrl}
              name={product.name}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
